<ng-container
  *ngrxLet="{
    usePriceDisplayComponent: usePriceDisplayComponent$,
    providers: priceDisplayDataProvider$
  } as vm"
>
  <!-- PLS Price Display Component -->
  @if (vm.usePriceDisplayComponent && vm.providers) {
    <cc-lazy-host [componentId]="priceDisplayComponent" [providers]="vm.providers" />
  }

  <!-- boring no PLS price display -->
  <ng-container *ngTemplateOutlet="noPLS; context: { usePriceDisplayComponent: vm.usePriceDisplayComponent }" />
</ng-container>

<ng-template #noPLS let-usePriceDisplayComponent="usePriceDisplayComponent">
  @if (vehiclePriceInformation$ | async; as priceInformation) {
    @if (!usePriceDisplayComponent) {
      {{ discountedOrConfigurationPrice(priceInformation) | formattedPrice | async }}
      <cc-footnote-rrp-hint component="prizeDisplayContainer" />
      @if (priceInformation.discountedPrice) {
        <cc-footnote-hint
          class="cc-header-info__environmental-bonus-footnote-hint"
          hint="{{ footnoteHint.EnvironmentalBonus }}"
          component="environmentalBonus"
        />
      }
    }
  }
</ng-template>
